import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './style.scss?inline';
import { EVENTS } from './constants';

export default class SotbitEditableFieldGroup extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        startWithEditMode: { type: Boolean, attribute: 'start-with-edit-mode' },
        _isEditing: { state: true },
    };

    constructor() {
        super();

        this._isEditing = false;
        this._handleSlotChange = this._handleSlotChange.bind(this);
    }

    render() {
        return html`
            <slot part="fields" @slotchange="${this._handleSlotChange}"></slot>
            <div part="buttons">
                <slot part=${this._isEditing ? 'edit hidden' : 'edit'} name="edit" @click=${this.edit}></slot>
                <slot part=${this._isEditing ? 'save' : 'save hidden'} name="save" @click=${this.save}></slot>
                <slot part=${this._isEditing ? 'cancel' : 'cancel hidden'} name="cancel" @click=${this.cancel}></slot>
            </div>
        `;
    }

    edit() {
        if (this._isEditing) {
            return;
        }

        if (
            !this.dispatchEvent(
                new CustomEvent(EVENTS.START_EDIT, {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                })
            )
        ) {
            return;
        }

        this._isEditing = true;

        this.getFields().forEach((field) => field.edit(false));
    }

    save() {
        if (!this._isEditing) {
            return;
        }

        if (
            !this.dispatchEvent(
                new CustomEvent(EVENTS.SAVE_EDIT, {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                })
            )
        ) {
            return;
        }

        try {
            this.getFields().forEach((field) => field.save(false));
        } catch {
            return;
        }

        this._isEditing = false;
    }

    cancel() {
        if (!this._isEditing) {
            return;
        }

        if (
            !this.dispatchEvent(
                new CustomEvent(EVENTS.CANCEL_EDIT, {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                })
            )
        ) {
            return;
        }

        this._isEditing = false;

        this.getFields().forEach((field) => field.cancel(false));
    }

    getFields() {
        return this.querySelectorAll('sotbit-editable-field') || [];
    }

    connectedCallback() {
        super.connectedCallback();

        if (this.startWithEditMode) {
            this.edit(false);
        }

        this.addEventListener(EVENTS.START_EDIT, (event) => event.stopPropagation());
        this.addEventListener(EVENTS.SAVE_EDIT, (event) => event.stopPropagation());
        this.addEventListener(EVENTS.CANCEL_EDIT, (event) => event.stopPropagation());
    }

    _handleSlotChange({ target }) {
        const fields = target.assignedElements();

        fields.forEach((field) => {
            if (this._isEditing) {
                if (!field._isEditing) {
                    field.edit(false);
                }
            } else {
                if (field._isEditing) {
                    field.cancel(false);
                }
            }
        });
    }
}
